import * as configUtils from "util/config";

export const transferReasons = configUtils.getArray("transfer.reasons", [
    "ALQ",
    "CUO",
    "EXP",
    "FAC",
    "HAB",
    "HON",
    "PRE",
    "SEG",
    "VAR",
]);

export const transferTypes = configUtils.getArray("transfer.types", ["OTHER", "SAME"]);

export default transferReasons;
